import React from 'react'
import PropTypes from 'prop-types'
import { users } from '../redux'

const UserInfoItem = ({ user }) => (
    <li>
        <div className="user-info">
            <div className="user-name">
                { users.fullName(user) || user.email || user.phone }
            </div>
            <div className="user-position online">Available</div>
        </div>
    </li>
)

UserInfoItem.propTypes = {
    user: PropTypes.object.isRequired
}

export default UserInfoItem
